module.exports = __webpack_public_path__ + "img/rshareIcon.13d38eb3.png";